import React, { useEffect, useState } from "react";
import axios from "axios";

import "../styles/App.scss";
import Router from "next/router";

import ClickStreamKit from "../data/ClickStreamKit";

import { UserContext } from "../contexts/UserContext";
import { AudioAppContext } from "../contexts/AudioContext";
import { GlobalPageDataContext } from "../contexts/GlobalPageDataContext";

// import { initGA, logPageView } from "../components/GoogleAnalytics.js";
import { EventContext } from "../contexts/EventContext";
import { AgentContext } from "../contexts/AgentContext";
import { ChatContext } from "../contexts/ChatContext";
import { ScreenContext } from "../contexts/ScreenContext";
import { DeviceContext } from "../contexts/DeviceContext";

import { useDevice } from "../hooks/useDevice";
import useAudioContext from "../hooks/useAudioContext";
import Head from "next/head";

import Script from "next/script";
import * as gtag from "../custom_gtag"
import EventKit from "../data/EventKit";
import AuthKit from "../data/AuthKit";

import eventUserAvailabilityStatus from "../data/enums/eventUserAvailabilityStatus";

export default function MyApp({ Component, pageProps }) {
  const [me, setMe] = useState(null);
  const [agentMe, setAgentMe] = useState(null);
  const [globalPageData, setGlobalPageData] = useState({});
  const [globalEventData, setGlobalEventData] = useState(null);
  const [unreadMessages, setUnreadMessages] = useState({});

  const [hasUnreadMessages, setHasUnreadMessages] = useState(false);
  const [isActiveBurger, setisActiveBurger] = useState(false);

  const [inMobileView, setinMobileView] = useState("home");
  const [initChatWindow, setInitChatWindow] = useState(false);
  const [toggleChat, setToggleChat] = useState(false);

  const [previousMessageCount, setPreviousMessageCount] = useState(0);

  const device = useDevice();
  const {
    mute,
    setMute,
    videoMuted,
    setVideoMuted,
    audioPlaybackAllowed,
    setAudioPlaybackAllowed,
    videoPlaybackAllowed,
    interactedWithVideo,
    setInteractedWithVideo,
    sounds,
  } = useAudioContext();

  const clickStreamKit = new ClickStreamKit();
  const eventKit = new EventKit()

  function onDone() {
    // triggerGoogleAnalytics();
    const url = Router.asPath;
    gtag.pageview(url);
    const event = Router.query.event;
    if (url && event) {
      clickStreamKit
        .createStream(event, url)
        .then((data) => { })
        .catch((error) => console.log(error));
    }
  }

  // function triggerGoogleAnalytics() {
  //   if (!window.GA_INITIALIZED) {
  //     initGA();
  //     window.GA_INITIALIZED = true;
  //   }
  //   logPageView();
  // }

  useEffect(() => {
    Router.events.on("routeChangeComplete", onDone);
  }, []);

  useEffect(() => {
    const hasUnread = Object.entries(unreadMessages).some(
      ([chatID, unreadMessageCount]) => {
        if (unreadMessageCount > 0) {
          setPreviousMessageCount(unreadMessageCount);
          sounds.playEventUserNotificationSound(
            unreadMessageCount,
            previousMessageCount
          );
          return true;
        } else {
          return false;
        }
      }
    );
    setHasUnreadMessages(hasUnread);
  }, [unreadMessages]);

  const handleMouseMove = () => {
    if (globalEventData?.slug) {
      const newAvailability = eventUserAvailabilityStatus.ONLINE;
      const payload = {
        availability: newAvailability,
      };
      eventKit
        .updateEventUserMe(globalEventData?.slug, payload)
        .catch((errors) => {
          console.log(errors);
        });
    }
  }

  const throttle = (cb, delay) => {
    let throttling = false;

    return (...args) => {
      if (!throttling) {
        throttling = true;

        cb(...args);

        setTimeout(() => {
          throttling = false;
        }, delay);
      }
    };
  };

  const HANDLE_MOVE_TIMER = 1000 * 60
  useEffect(() => {
    window.addEventListener("mousemove", throttle(handleMouseMove, HANDLE_MOVE_TIMER))
    return () => {
      window.removeEventListener("mousemove", throttle(handleMouseMove, HANDLE_MOVE_TIMER))
    }
  }, [globalEventData])


  const handleBeforeUnload = () => {
    if (globalEventData?.slug) {
      const newAvailability = eventUserAvailabilityStatus.OFFLINE;
      const payload = {
        availability: newAvailability,
      };
      const authKit = new AuthKit()
      let url = `${authKit._getBaseURL()}/${authKit._getApiURL()}/events/event-users/${globalEventData?.slug}/me/`;
      const response = axios.patch(url, payload, {
        headers: {
          "Authorization": `Bearer ${authKit.getToken()}`
        }  
      });
    }
  }


  useEffect(() => {
    window.addEventListener("beforeunload", handleBeforeUnload)
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload)
    }
  }, [globalEventData])

  return (
    <DeviceContext.Provider value={device}>
      <ScreenContext.Provider
        value={{
          inMobileView,
          setinMobileView,
          isActiveBurger,
          setisActiveBurger,
        }}
      >
        <EventContext.Provider value={{ globalEventData, setGlobalEventData }}>
          <AudioAppContext.Provider
            value={{
              mute,
              setMute,
              videoMuted,
              setVideoMuted,
              playNewMessageSound: sounds.playAgentUserNotificationSound,
              audioPlaybackAllowed,
              setAudioPlaybackAllowed,
              videoPlaybackAllowed,
              interactedWithVideo,
              setInteractedWithVideo,
            }}
          >
            <UserContext.Provider value={{ me, setMe }}>
              <AgentContext.Provider value={{ agentMe, setAgentMe }}>
                <ChatContext.Provider
                  value={{
                    hasUnreadMessages,
                    setUnreadMessages,
                    unreadMessages,
                    initChatWindow,
                    setInitChatWindow,
                    toggleChat,
                    setToggleChat,
                  }}
                >
                  <GlobalPageDataContext.Provider
                    value={{
                      globalPageData,
                      setGlobalPageData,
                    }}
                  >
                    <Head>
                      <meta
                        name="viewport"
                        content="width=device-width, initial-scale=1.0"
                      ></meta>
                    </Head>
                    <Script 
                      async
                      strategy="afterInteractive"
                      src="https://www.googletagmanager.com/gtag/js?id=G-RN5LTF3SME"
                    />
                    <Script
                      strategy="afterInteractive"
                      dangerouslySetInnerHTML={{
                        __html: `
                          window.dataLayer = window.dataLayer || [];
                          function gtag(){dataLayer.push(arguments);}
                          gtag('js', new Date());
                          gtag('config', 'G-RN5LTF3SME', {
                            page_path: window.location.pathname,
                          });
                        `,
                      }}
                    />
                    <Script
                      strategy="afterInteractive"
                      dangerouslySetInnerHTML={{
                        __html: `
                          (function(c,l,a,r,i,t,y){
                          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                          })(window, document, "clarity", "script", "icxd9kpc2b");
                          
                        `,
                      }}
                    />
                    <Component {...pageProps} />
                  </GlobalPageDataContext.Provider>
                </ChatContext.Provider>
              </AgentContext.Provider>
            </UserContext.Provider>
          </AudioAppContext.Provider>
        </EventContext.Provider>
      </ScreenContext.Provider>
    </DeviceContext.Provider>
  );
}
